import { FC } from 'react';
import MojoLogoSvg from './mojo-logo.svg';

type MojoLogoProps = Omit<JSX.IntrinsicElements['img'], 'src'> & {
    alt?: string;
};

const MojoLogo: FC<MojoLogoProps> = ({ alt = 'Mojo', ...props }) => {
    return <img src={MojoLogoSvg} alt={alt} {...props} />;
};

export default MojoLogo;
